export default __webpack_public_path__ + "static/media/ibotta2.4c37341a.webp";